import BankAccount from "@/entities/bank-account";
import ClientLike from "../client-like";

/**
 * 振込先情報のAPI
 */
export default class BankAccountApi {
  constructor(private client: ClientLike) {}

  /**
   * 現在のユーザーが所属する支店に紐づいた請求の振込先を取ってくる
   */
  public async ourBankAccounts(options: SearchOptions): Promise<BankAccount[]> {
    const data = await this.client.get("get_bank_account.php", options);
    return data;
  }
}

interface SearchOptions {
  projectId: number;
}
